<template>
  <div id="edit-supplier-quality">
    <Title :titlePage="titlePage" />
    <v-container class="form-container py-6">
      <SupplierQualityForm
        :supplierQuality="supplierQuality"
        :supplierQuality_a_articles="supplierQuality_a_articles"
        :mode="mode"
        @emitSupplierQuality="createOrUpdateSupplierQuality"
      />
      <Popup :dialog="dialog" :text="messageCreation" :actions="actions" />
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/shared/Title";
import SupplierQualityForm from "@/components/Forms/SupplierQualityForm";
import Popup from "@/components/shared/Popup";
import apiSupplierQuality from "@/api/supplier_quality";

export default {
  name: "EditSupplierQuality",
  components: { Title, SupplierQualityForm, Popup },
  data() {
    return {
      supplierQuality: {
        id: null,
        date: "",
        supplier: "",
        non_compliance_fta_number: "",
        contact: "",
        email: "",
        code_production_comment: "",
        description: "",
        estimated_cost: "",
        estimated_cost_description: "",
        is_accepted: false,
        refusal_reason: "",
        non_compliance_number: "",
        need_return: false,
        delivery_type: "",
        shipping_date: null,
        carrier: "",
        package_detail: "",
        status: "",
      },
      mode: "",
      titlePage: "",
      dialog: false,
      messageCreation: "",
      actions: "supplier_quality",
      yearCount: 0,
      supplierQuality_a_articles: [],
    };
  },
  watch: {
    'supplierQuality.supplier': {
      handler(newSupplier, oldSupplier) {
        if (this.mode === 'creation' && newSupplier && newSupplier !== oldSupplier) {
          this.generateNonComplianceNumber();
        }
      },
    },
  },
  methods: {
    initializePage() {
      const routeName = this.$route.name;
      const id = this.$route.params.id;

      if (routeName === 'view_supplier_quality') {
        this.mode = "visualisation";
        this.titlePage = "Voir Qualité Fournisseur";
        this.getSupplierQuality(id);
      } else if (routeName === 'update_supplier_quality') {
        this.mode = "modification";
        this.titlePage = "Modifier Qualité Fournisseur";
        this.getSupplierQuality(id);
      } else {
        this.mode = "creation";
        this.titlePage = "Créer Qualité Fournisseur";
        this.supplierQuality.date = new Date().toISOString().split('T')[0];
        this.fetchYearCount();
      }
    },
    getSupplierQuality(id) {
      apiSupplierQuality.getSupplierQuality(id).then((res) => {
        this.supplierQuality = {
          ...res.data.supplier_quality,
          date: res.data.supplier_quality.date ? res.data.supplier_quality.date.split('T')[0] : "",
          shipping_date: res.data.supplier_quality.shipping_date ? res.data.supplier_quality.shipping_date.split('T')[0] : null,
        };
        this.supplierQuality_a_articles = res.data.supplier_quality.products || [];
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    createOrUpdateSupplierQuality(supplierQuality) {
      if (this.mode === "modification") {
        this.updateSupplierQuality(supplierQuality);
      } else {
        this.createSupplierQuality(supplierQuality);
      }
    },
    createSupplierQuality(supplierQuality) {
      apiSupplierQuality.createSupplierQuality({ ...supplierQuality, products: this.supplierQuality_a_articles })
        .then(() => {
          this.messageCreation = "Qualité fournisseur créée avec succès";
          this.dialog = true;
          setTimeout(() => { this.$router.push({ name: "supplier_quality" }); }, 2000);
        })
        .catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
        });
    },
    updateSupplierQuality(supplierQuality) {
      apiSupplierQuality.updateSupplierQuality(supplierQuality.id, { ...supplierQuality, products: this.supplierQuality_a_articles })
        .then(() => {
          this.messageCreation = "Qualité fournisseur modifiée avec succès";
          this.dialog = true;
          setTimeout(() => { this.$router.push({ name: "supplier_quality" }); }, 2000);
        })
        .catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
        });
    },
    fetchYearCount() {
      apiSupplierQuality.getYearCount(new Date().getFullYear())
        .then((res) => {
          this.yearCount = res.data.count || 0;
          if (this.mode === 'creation' && this.supplierQuality.supplier) {
            this.generateNonComplianceNumber();
          }
        })
        .catch(() => { this.yearCount = 0; });
    },
    generateNonComplianceNumber() {
      const year = new Date().getFullYear();
      const supplier = this.supplierQuality.supplier.toUpperCase();
      this.supplierQuality.non_compliance_fta_number = `${year} - ${supplier} - ${this.yearCount + 1}`;
    },
  },
  created() {
    this.initializePage();
  },
};
</script>

<style scoped lang="scss">
#edit-supplier-quality {
  min-height: 100%;
}

.form-container {
  max-width: 960px;
}
</style>
